import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";

interface ServicesStatsProps {
  totalServices: number;
  totalCategories: number;
}

export function ServicesStats({ totalServices, totalCategories }: ServicesStatsProps) {
  const { t } = useTranslation("services");

  return (
    <div className="flex items-center gap-2">
      <Badge variant="secondary" className="text-xs">
        {t("stats.services", { count: totalServices })}
      </Badge>
      <Badge variant="secondary" className="text-xs">
        {t("stats.categories", { count: totalCategories })}
      </Badge>
    </div>
  );
}
